import { isDefine } from 'helpers';
// import jwt from 'jsonwebtoken';
import * as jose from 'jose'
import { isPlainObject } from 'lodash';
import querystring from 'query-string';

const secretKey = 'textback';

class FiltersService {
  getInitialFilters() {
    return querystring.parse(window?.location?.search || '')?.filters || undefined;
  }

  decodeFilters(tokenFilters) {
    if (isDefine(tokenFilters)) {
      // const obj = jwt.decode(tokenFilters);
      const obj = jose.decodeJwt(tokenFilters);
      delete obj.iat;
      return obj;
    }

    return {};
  }

  encodeFilters(filters) {
    let newFilters = {};
    Object.entries(filters).forEach(([key, value]) => {
      if (isPlainObject(value)) {
        if ('label' in value) {
          newFilters = {
            ...newFilters,
            [key]: { label: value.label, value: value.value },
          };
        } else {
          newFilters = {
            ...newFilters,
            [key]: value,
          };
        }
      } else {
        newFilters = {
          ...newFilters,
          [key]: value,
        };
      }
    });

    new jose.SignJWT(newFilters)
      .setProtectedHeader({ alg: 'HS256' })
      .sign(secretKey).then((jwt) => {
        return jwt;
      })
    // return jose.sign(newFilters, secretKey);
  }
}

export default new FiltersService();
